import { useAccess } from '../../auth/useAccess.js';

/**
 * Who may do what to a job, mirroring the api worker's gates (HIDING IS UX; the server re-checks):
 *
 *   POST /jobs                                  jobs.create
 *   PATCH /jobs/:id                             jobs.edit
 *   POST /jobs/merge                            Manager+ and jobs.edit
 *   POST /estimates/:id/convert,
 *   POST /invoices/:id/create-job,
 *   POST /servicetitan/jobs/:id/import          Manager+ and jobs.create
 */
export function useJobAccess() {
  const canAccess = useAccess();
  const isManager = canAccess({ minRole: 'Manager' });
  const canCreate = canAccess({ permission: 'jobs.create' });
  const canEdit = canAccess({ permission: 'jobs.edit' });
  return {
    canCreate,
    canEdit,
    canMerge: isManager && canEdit,
    canCreateFromRecord: isManager && canCreate,
  };
}
